import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Selector from '../../../../common/custom-selector';
import { DESKTOP, MOBILE, TABLET, ALL } from '../../../../../models/device-type';
import Icon from 'utils/components/icon';

class DeviceSelector extends Component {
  constructor(props, context) {
    super(props, context);
    var device = props.analytics.get('device');
    // var device = props.analytics.device;

    this.state = { device };
  }
  onChange(value) {
    var { spotId, analytics } = this.props;

    if (this.refs.selector) {
      this.refs.selector.hide();
    }

    if (value !== this.state.device) {
      this.setState({ device: value });

      let params = {
        spotId,
        device: value,
        resolution: analytics.get('resolution'),
        period: analytics.get('period'),
        fromDay: analytics.get('from_day'),
        toDay: analytics.get('to_day')
      };
      this.props.dateChange(params);
    }
  }
  isChecked(device) {
    return this.state.device === device ? 'checked' : '';
  }
  render() {
    var { device } = this.state;
    var items = [
      {
        value: ALL,
        element: (
          <div className="device-item" onClick={this.onChange.bind(this, ALL)}>
            <div className="icon-wrapper">
              <Icon name="desktop-mobile" className="desktop-mobile-icon device-icon" />
            </div>
            All Devices
            {this.isChecked(ALL) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </div>
        )
      },
      {
        value: DESKTOP,
        element: (
          <div className="device-item" onClick={this.onChange.bind(this, DESKTOP)}>
            <div className="icon-wrapper">
              <Icon name="desktop" className="desktop-icon device-icon" />
            </div>
            Desktops
            {this.isChecked(DESKTOP) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </div>
        )
      },
      {
        value: TABLET,
        element: (
          <div className="device-item" onClick={this.onChange.bind(this, TABLET)}>
            <div className="icon-wrapper">
              <Icon name="tablet" className="tablet-icon device-icon" />
            </div>
            Tablets
            {this.isChecked(TABLET) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </div>
        )
      },
      {
        value: MOBILE,
        element: (
          <div className="device-item" onClick={this.onChange.bind(this, MOBILE)}>
            <div className="icon-wrapper">
              <Icon name="mobile" className="mobile-icon device-icon" />
            </div>
            Phones
            {this.isChecked(MOBILE) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </div>
        )
      }
    ];

    return (
      <div className="device-selector">
        <Selector ref="selector" items={items} selected={device} width={184} />
      </div>
    );
  }
}

DeviceSelector.displayName = 'DeviceSelector';

export default DeviceSelector;
